/**
 * MPC External Demo 路由配置
 *
 * 开发模式下从生成的文件导入
 * 生产模式下或文件不存在时返回空数组
 */

let demoRoutes: any[] = [];
let isDemoMode = false;

try {
  // 动态 require 避免编译时依赖
  const generated = require('./demo-routes.generated');
  demoRoutes = generated.demoRoutes || [];
  isDemoMode = generated.isDemoMode ?? false;
} catch (e) {
  // 文件不存在时静默处理，Demo 功能不可用但主应用正常编译
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[DemoRoutes] 未找到 demo-routes.generated.ts，Demo 功能暂不可用');
  }
}

export { demoRoutes, isDemoMode };
